/* ROTAS69 — editorial mega-menu pane.
   The dark pane (.r69-mpane) is rendered SERVER-SIDE in blocks/_header-menu.liquid,
   so it is always present in every render (initial + Horizon's Section Rendering API
   re-render on first hover) — no JS injection, no missing pane, no layout shift.
   This script only live-updates the pane's name / kicker / "view all" link as the
   pointer moves over the child links, and re-binds after the submenu is re-rendered. */
(function () {
  // Auto-shrink the pane title so long names always fit.
  function setName(el, text) {
    el.textContent = text;
    var l = text.length;
    el.style.fontSize = (l <= 11 ? 46 : l <= 18 ? 38 : l <= 26 ? 31 : l <= 34 ? 26 : 22) + 'px';
  }

  function bindPane(sub) {
    var pane = sub.querySelector('.r69-mpane');
    if (!pane || pane.dataset.r69bound) return;
    pane.dataset.r69bound = '1';

    var nameEl = pane.querySelector('.r69-mpane__n');
    var kEl = pane.querySelector('.r69-mpane__k');
    var ctaEl = pane.querySelector('.r69-mpane__c');
    var baseName = nameEl ? nameEl.textContent.trim() : '';
    var baseKicker = kEl ? kEl.textContent.trim() : 'Kolekcija';
    var baseHref = ctaEl ? ctaEl.getAttribute('href') : null;
    if (nameEl) setName(nameEl, baseName);

    sub.querySelectorAll('.mega-menu__link:not(.mega-menu__link--parent)').forEach(function (a) {
      a.addEventListener('mouseenter', function () {
        var t = a.querySelector('.wrap-text') || a;
        if (nameEl) setName(nameEl, t.textContent.trim());
        var col = a.closest('.mega-menu__column');
        var ph = col && col.querySelector('.mega-menu__link--parent .wrap-text');
        if (kEl) kEl.textContent = ph ? ph.textContent.trim() : baseKicker;
        if (ctaEl && a.getAttribute('href')) ctaEl.setAttribute('href', a.getAttribute('href'));
      });
      a.addEventListener('mouseleave', function () {
        if (nameEl) setName(nameEl, baseName);
        if (kEl) kEl.textContent = baseKicker;
        if (ctaEl && baseHref) ctaEl.setAttribute('href', baseHref);
      });
    });
  }

  function run() {
    document.querySelectorAll('header-menu .menu-list__submenu').forEach(bindPane);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);

  // Horizon re-renders the submenu (Section Rendering API) on first hover, replacing
  // the pane with a fresh server-rendered one — re-bind then. Throttled to one pass/frame.
  var pending = false;
  document.addEventListener(
    'pointerover',
    function (e) {
      if (pending || !(e.target && e.target.closest && e.target.closest('header-menu'))) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        run();
      });
    },
    { passive: true }
  );
})();
